var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container collapse"},[_c('div',{key:"collapse",staticClass:"sidebar-logo-link"},[_c('h3',{staticClass:"sidebar-title",staticStyle:{"color":"#3976f6","font-size":"18px","font-weight":"600"}},[_vm._v("PRIME")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }